<template>
  <div>
    <v-radio-group
      :model-value="envelopeType"
      required
      :disabled="isEditingLimited"
      class="envelopeType__container"
      :error-messages="envelopeTypeErrorMessages"
    >
      <div v-for="option in envelopeTypeOptions" :key="`option-${option}`">
        <div
          class="envelopeType__card"
          :class="{ 'envelopeType__card--active': option === envelopeType }"
          @click="onEnvelopeTypeChange(option)"
        >
          <v-radio :true-value="option">
            <template #label>
              <div class="w-100 d-flex align-center justify-space-between">
                <h4 class="text-text-primary">
                  {{ $t(`project.signing-checklist.add.SigningChecklistSectionDocumentEnvelopeType.envelopeTypeOptions.${option}`) }}
                </h4>
                <span v-if="option === ENVELOPE_TYPES.SINGLE && isMultiEnvelopeChild" class="text-text-secondary">
                  ({{ $t('common.envelopeType.fromBulk') }})
                </span>
                <v-chip
                  v-if="option === ENVELOPE_TYPES.MULTIPLE"
                  variant="outlined"
                  color="primary"
                  size="small"
                >
                  {{ $t('common.new') }}
                </v-chip>
              </div>
              <p class="text-text-tertiary text--caption">
                {{
                  $t(`project.signing-checklist.add.SigningChecklistSectionDocumentEnvelopeType.envelopeTypeOptions.${option}Info`)
                }}
              </p>
            </template>
          </v-radio>
        </div>
      </div>
    </v-radio-group>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { formFieldErrors, VuelidateFormField } from '@/common/utils/form'
import { ENVELOPE_TYPES } from '@/project/signing-checklist/constants'

export default defineComponent({
  name: 'SigningChecklistSectionDocumentEnvelopeType',
  props: {
    envelopeType: {
      type: String,
      required: true,
    },
    isEditingLimited: {
      type: Boolean,
      required: true,
    },
    isMultiEnvelopeChild: {
      type: Boolean,
      required: true,
    },
    envelopeTypeValidator: {
      type: Object as PropType<VuelidateFormField>,
      required: true,
    },
  },
  data () {
    return {
      ENVELOPE_TYPES,
    }
  },
  computed: {
    envelopeTypeOptions (): string[] {
      return Object.values(ENVELOPE_TYPES).filter((type) => type !== ENVELOPE_TYPES.NDA)
    },
    envelopeTypeErrorMessages () {
      return formFieldErrors(
        this.envelopeTypeValidator,
        [
          ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('project.signing-checklist.add.SigningChecklistSectionDocumentEnvelopeType.envelopeTypeLabel') })],
        ],
      )
    },
  },
  methods: {
    onEnvelopeTypeChange (value: string | null) {
      this.$emit('envelope-type-change', value)
    },
  },
})
</script>

<style scoped lang="scss">
.envelopeType__container {
  :deep( .v-selection-control-group) {
    width: 100%;
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
}

.envelopeType__card {
  justify-self: stretch;
  border: 1px solid rgb(var(--v-theme-border-secondary));
  border-radius: 8px;
  overflow: hidden;
  margin: 0 !important;
  cursor: pointer;

  &--active {
    outline: 2px solid rgb(var(--v-theme-border-info-bold));
    outline-offset: -2px;
    background-color: rgb(var(--v-theme-surface-info));
  }

  :deep(.v-label) {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.v-selection-control {
  padding-block: 16px;
  padding-left: 24px;
  padding-right: 8px;

  :deep(.v-label){
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}
</style>
